import { lazy } from 'react';
import { Navigate, useLocation, useRoutes } from 'react-router';
import Loadable from './Loadable';
import { useInitialize } from 'hooks/useInitialize';
import DashboardLayout from 'layouts/DashboardLayout';
import Loading from "views/Loading";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from 'core/Auth/Templates';

const NotFound = Loadable(lazy(() => import('views/NotFound')));
const Login = Loadable(lazy(() => import('views/Login')));
const Question = Loadable(lazy(() => import('views/Question')));

const ExecuteLogin = () => {

  const { pathname } = useLocation();

  return <Navigate to={"/login?redirect=" + pathname} />
}

const openRoutes = [
  {
    path: '/Login',
    element: (
      <Login />
    )
  },
  {
    path: "*",
    element: <ExecuteLogin />
  }
]

const routes = [
  {
    path: '/',
    element: (
      <DashboardLayout />
    ),
    children: [
      {
        path: "question/:id",
        element: <Question />
      },
      {
        path: "login",
        element: <Navigate to="/" />
      },
      {
        path: '*',
        element: <NotFound />
      },
    ]
  },
]

function Routes() {

  const content = useRoutes(routes);
  const contentOpen = useRoutes(openRoutes);
  const { isLoading } = useInitialize();

  if (isLoading) {
    return <Loading />
  }

  return (
    <>
      <UnauthenticatedTemplate>
        {contentOpen}
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        {content}
      </AuthenticatedTemplate>
    </>
  )
}

export default Routes
